module.exports = __webpack_public_path__ + "img/fb.ecd99c28.svg";